module.exports = __webpack_public_path__ + "static/img/IMG_1809_04.b2d6daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_1809_04.png
// module id = X3GR
// module chunks = 1